export const getAdPreviewStyles = (components, { palette = {} }) => ({
  adPreviewContainer: {
    '& .new-preview-carousel-container-adprelib': {
      border: 0,
      boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
      borderRadius: '2px',
      backgroundColor: `${palette.white}`,
    },
    '& .ad-preview-controls-container': {
      paddingBottom: 10,
    },
    '& .ad-preview-actions': {
      '& button': {
        marginRight: 8,
      },
    },
    '& .ad-preview-title': {
      '& .preview-title-string-key': {
        fontSize: 14,
        fontWeight: 'bold',
        marginRight: 8,
      },
      '& .preview-title-preview-type': {
        fontSize: 14,
      },
    },
    '& .preview-type-string': {
      visibility: 'hidden',
    },
    '& .carousel-wrapper': {
      '& .carousel-inner': {
        height: 515,
        merginTop: 10,
      },
      '& .carousel-control': {
        background: 'transparent',
      },
    },
  },

  carouselLayoutClassName: {
    border: 0,
    boxShadow: '0px 0.3px 0.9px rgba(0, 0, 0, 0.1), 0px 1.6px 3.6px rgba(0, 0, 0, 0.13)',
    borderRadius: '2px',
    backgroundColor: `${palette.white}`,

    '& .carousel-wrapper': {
      '& .carousel-inner': {
        height: 515,
      },
      '& .carousel-control.left, .carousel-control.right': {
        left: 0,
        bottom: -7,
        background: 'transparent',
        zIndex: 20,
      },
    },
  },
  carouselControlsMsn: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 200,
      },
      '& .carousel-control.right': {
        marginLeft: 430,
      },
      '& .carousel-indicators': {
        marginLeft: 240,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
  carouselControlsOthers: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 270,
      },
      '& .carousel-control.right': {
        marginLeft: 357,
      },
      '& .carousel-indicators': {
        marginLeft: 310,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
  customCarouselRoot: {
    '& .custom-carousel-controls-and-indicators': {
      transform: 'translateX(-15px) translateX(-50%)',
      left: '50%',

      '& .carousel-control.left': {
        marginRight: '10px !important',
      },
      '& .carousel-control.right': {
        marginLeft: '5px !important',
      },
    },
  },
  adExtensionContainer: {
    // todo: add styles for ad extension preview components if needed
    margin: 10,
  },
  placementContainerClassName: {
    minWidth: 669,
    border: '0 !important',
    boxShadow: 'unset !important',
    borderRadius: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',

    '& .placement-validation-message': {
      display: 'inline-block',
      width: '100%',
      fontSize: 14,
      textAlign: 'center',
      lineHeight: 2,
      marginRight: 16,
    },
  },
  carouselLayoutHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',

    '& .carousel-header-texts': {
      display: 'inline-block',
      margin: '20px 8px 16px 24px',
      fontSize: 18,
      lineHeight: '24px',

      '& .carousel-header-ratio': {
        fontSize: 14,
        fontWeight: 'bold',
        marginRight: 8,
      },
      '& .carousel-header-title': {
        fontSize: 14,
      },
    },
    '& .ad-preview-actions': {
      display: 'flex',
      flexDirection: 'row',
      flexGrow: 0,
      flexShrink: 0,
      alignItems: 'center',
      marginRight: 16,
      '& button': {
        marginRight: 8,
      },
    },
  },
});

const geCarouselStyleForMsan = {
  root: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 200,
      },
      '& .carousel-control.right': {
        marginLeft: 430,
      },
    },
  },
  previewCarousel: {
    bottomCarouselNavigation: {
      '& .carousel-indicators': {
        marginLeft: 240,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
};

const geCarouselStyleForOthers = {
  root: {
    '& .carousel-wrapper': {
      '& .carousel-control.left': {
        marginLeft: 270,
      },
      '& .carousel-control.right': {
        marginLeft: 357,
      },
    },
  },
  previewCarousel: {
    bottomCarouselNavigation: {
      '& .carousel-indicators': {
        marginLeft: 310,
        margin: '20px 24px',
        left: 0,
      },
    },
  },
};

export const getCarouselControlsAndIndicatorsStyleBySurface = (surface) => {
  switch (surface) {
    case 'Bing':
    case 'Edge':
    case 'Outlook':
      return geCarouselStyleForOthers;
    case 'Msn':
    default:
      return geCarouselStyleForMsan;
  }
};
